import { SetSnackBar } from './SnackbarHelper';

export function HandleError(errorMsg: string = '', additionalActions = () => {}) {
  if (!errorMsg) {
    errorMsg =
      'Something went wrong. Please contact techsupport@just1label.com for more information.';
  }
  SetSnackBar(errorMsg);
  if (additionalActions) {
    additionalActions();
  }
}
